import { gql } from "@apollo/client";

export const ACTIVE_WALLHALLA_MANIFEST_QUERY = gql`
    query ActiveWallhallaManifest {
        activeWallhallaManifest {
            manifestUrl
        }
    }
`;

export const ALL_WALLHALLA_MANIFESTS_QUERY = gql`
    query AllWallhallaManifests {
        allWallhallaManifests {
            id
            version
            isActive
            sourceWidth
            sourceHeight
            stripCount
            createdAt
            manifestUrl
        }
    }
`;
